import React from "react";
import Helmet from "react-helmet";
import PropTypes from "prop-types";

DocumentTitle.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
}

export default function DocumentTitle(props) {
  return (
      <>
          <Helmet>
              <title>{props.title}</title>
          </Helmet>
          {props.children}
      </>
  );
}